import {ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, Input, OnInit, ViewChild, ViewEncapsulation} from "@angular/core";
import {TranslationsFormService} from "../translations-form.service";
import {StandardName} from "../../../store/state/order.state";
import {StandaloneFormComponent} from "../../../umbrella-common/components/standalone-form.component";
import {delay, takeWhile} from "rxjs/operators";

@Component({
    selector: 'translation-field',
    templateUrl: './translation-field-template.html',
    styleUrls: ['./translation-field.style.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class TranslationFieldComponent extends StandaloneFormComponent implements OnInit {

	@Input() standard: StandardName;
	@Input() translationSubject: string;
	@Input() translatedText: string;
	@Input() isComment: boolean = false;
	@Input() previewMode: boolean = false;
	@ViewChild('textAreaElement', {static: true}) textAreaElement: ElementRef<HTMLTextAreaElement>;

	private alive: boolean = false;

	constructor(public formService: TranslationsFormService, private changeDet: ChangeDetectorRef) {
		super(formService);
	}

	ngOnInit(): void {
		this.alive = true;
		this.formService.onSubmitClicked$().pipe(takeWhile(() => this.alive), delay(200)).subscribe(() => this.changeDet.detectChanges());
	}

	htmlPrefix(): string {
		return this.isComment ? 'translation-comment' : this.translationSubject + '-translation-' + this.standard;
	}

	getControlName(): string {
		return this.isComment ? 'comment' : `${this.standard}-${this.translationSubject}`;
	}

	autoGrow() {
		if (this.textAreaElement.nativeElement.scrollHeight > this.textAreaElement.nativeElement.clientHeight) {
			this.textAreaElement.nativeElement.style.height = this.textAreaElement.nativeElement.scrollHeight + 'px';
		}
	}

	override ngOnDestroy() {
		this.alive = false;
		// super not called to prevent translation service from destroying when accordion is collapsed
	}
}
